/* Native add-on picker.

   Each ticked add-on is a real product variant, so on submit we send the main
   product plus the extras to /cart/add.js as separate line items. That keeps
   inventory and fulfilment honest, which a price-only option cannot do.

   The theme's own <product-form> handles the normal single-item submit. We
   intercept only when at least one add-on is ticked, so the default path is
   untouched when nobody adds anything. */
(function () {
  var root = document.querySelector('[data-rgpp-addons]');
  if (!root) return;

  var form = document.querySelector('form[action*="/cart/add"]:not(.installment)');
  var inputs = [].slice.call(root.querySelectorAll('.addon-input'));
  /* Locked add-ons have no checkbox - they ship with the product either way,
     so they go on every order and the customer cannot remove them. */
  var lockedRows = [].slice.call(root.querySelectorAll('[data-locked-variant]'));
  var totalEl = root.querySelector('[data-rgpp-total]');
  var saveEl = root.querySelector('[data-rgpp-save]');
  var saveAmountEl = root.querySelector('[data-rgpp-save-amount]');
  var offerEl = root.querySelector('[data-rgpp-bundle-offer]');
  var offerAmountEl = root.querySelector('[data-rgpp-bundle-amount]');
  var offerBtn = root.querySelector('[data-rgpp-bundle-add]');
  var offerPromptEl = root.querySelector('[data-rgpp-bundle-prompt]');
  var bundleSaving = parseInt(root.dataset.bundleSaving || '0', 10);
  var bundleCount = parseInt(root.dataset.bundleCount || '0', 10);

  /* Spend tiers, mirroring the automatic order discounts in Shopify. Those are
     triggered by the cart subtotal, not by how many add-ons are ticked - two
     add-ons can qualify or not depending which two - so the picker has to
     compare the same running total rather than count boxes. Highest qualifying
     tier wins, which is what Shopify does when both minimums are met. */
  var tiers = [];
  try {
    /* a percentage kit discount (US) has no fixed saving: it is pct of the ticked bundle items */
    var pct = parseFloat(root.dataset.tierPercent || '0') || 0;
    tiers = JSON.parse(root.dataset.tiers || '[]')
      .filter(function (t) { return t && t.min > 0 && (t.save > 0 || pct > 0); })
      .sort(function (a, b) { return a.min - b.min; });
  } catch (e) { tiers = []; }

  /* Count tiers: the kit discounts ("Bundle - 3 accessories", "- 4 accessories")
     are triggered by how many kit items are in the cart, not by spend, so the
     picker counts ticked bundle items instead. Spend would also misfire on a
     second Grassifier. A tier needing more items than can currently be ticked
     (one is sold out) is dropped, so we never offer a saving nobody can reach. */
  var tierBasis = root.dataset.tierBasis || 'spend';
  function bundleTicked() {
    return inputs.filter(function (i) { return i.checked && !i.disabled && i.dataset.inBundle === 'true'; }).length;
  }
  if (tierBasis === 'count') {
    var reachable = inputs.filter(function (i) { return i.dataset.inBundle === 'true' && !i.disabled; }).length;
    tiers = tiers
      .map(function (t) { return { min: Math.round(t.min / 100), save: t.save, prompt: t.prompt }; })
      .filter(function (t) { return t.min <= reachable; });
  }

  function tierFor(total) {
    var hit = null;
    tiers.forEach(function (t) { if (total >= t.min) hit = t; });
    return hit;
  }

  function nextTier(total) {
    for (var i = 0; i < tiers.length; i++) { if (total < tiers[i].min) return tiers[i]; }
    return null;
  }

  /* Move the picker into the buy box so it reads as part of the form. If the
     form is not found it simply stays where the section sits. */
  if (form) {
    var anchor = form.querySelector('.product__submit__buttons, [class*="product__submit"]');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor);
  }

  function basePrice() {
    var el = document.querySelector('[data-rgpp-addons]');
    var attr = el && el.getAttribute('data-base-price');
    if (attr) return parseInt(attr, 10);
    /* fall back to the rendered price on the page */
    var priceNode = document.querySelector('.product__price .price-item, .product__price');
    if (!priceNode) return 0;
    var digits = priceNode.textContent.replace(/[^0-9.]/g, '');
    return Math.round(parseFloat(digits || '0') * 100);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function qty() {
    var q = form && form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function checked() {
    return inputs.filter(function (i) { return i.checked && !i.disabled; });
  }

  function update() {
    var sel = checked();
    /* an item made free by a checkout discount must not inflate the total */
    var extras = sel.reduce(function (sum, i) {
      if (i.dataset.freeNote) return sum;
      return sum + parseInt(i.dataset.price || '0', 10);
    }, 0);
    var lockedExtras = lockedRows.reduce(function (sum, el) {
      if (el.dataset.freeNote) return sum;
      return sum + parseInt(el.dataset.price || '0', 10);
    }, 0);
    var total = (basePrice() * qty()) + extras + lockedExtras;

    var hit, saving, pending;

    if (tiers.length) {
      var measure = tierBasis === 'count' ? bundleTicked() : total;
      hit = tierFor(measure);
      saving = hit ? hit.save : 0;
      if (hit && pct > 0) {
        saving = Math.round(sel.reduce(function (sum, i) {
          return i.dataset.inBundle === 'true' ? sum + parseInt(i.dataset.price || '0', 10) : sum;
        }, 0) * pct / 100);
      }
      /* always look one rung up: earning the first saving should move the offer
         on to the next one, not switch it off */
      pending = nextTier(measure);
    } else {
      var bundled = sel.filter(function (i) { return i.dataset.inBundle === 'true'; }).length;
      hit = (bundleSaving > 0 && bundleCount > 0 && bundled >= bundleCount) ? { save: bundleSaving } : null;
      saving = hit ? bundleSaving : 0;
      pending = hit ? null : (bundleSaving > 0 ? { save: bundleSaving } : null);
    }

    if (hit) total -= saving;
    if (totalEl) totalEl.textContent = money(total);

    if (saveEl) {
      saveEl.hidden = !hit;
      if (hit && saveAmountEl) saveAmountEl.textContent = money(saving);
    }
    /* the offer stays visible until they qualify, then swaps to the
       confirmation - never both at once */
    if (offerEl) {
      offerEl.hidden = !pending;
      if (pending) {
        /* Prompts may spell the figures out themselves with {save} for this
           tier and {top} for the best one, so a single line can offer both
           rungs at once. When they do, the separate amount is left empty
           rather than repeating it. */
        var top = tiers.length ? tiers[tiers.length - 1] : pending;
        /* {or_top} becomes ", or all 4 and save $x" only when a bigger rung
           exists and can be reached - so it vanishes while an item is sold out */
        var orTop = (top !== pending && tierBasis === 'count')
          ? ', or all ' + top.min + ' and save ' + money(top.save) : '';
        var text = (pending.prompt || '')
          .replace('{save}', pct > 0 ? pct + '%' : money(pending.save))
          .replace('{top}', money(top.save))
          .replace('{or_top}', orTop);
        if (offerPromptEl) offerPromptEl.textContent = text;
        if (offerAmountEl) offerAmountEl.textContent = (text.indexOf('$') > -1 || text.indexOf('%') > -1) ? '' : money(pending.save);
      }
    }

    sel.forEach(function () {});
    inputs.forEach(function (i) {
      var label = i.closest('.addon');
      if (label) label.classList.toggle('is-on', i.checked && !i.disabled);
    });
  }

  inputs.forEach(function (i) { i.addEventListener('change', update); });
  if (offerBtn) {
    offerBtn.addEventListener('click', function () {
      inputs.forEach(function (i) {
        if (i.dataset.inBundle === 'true' && !i.disabled) i.checked = true;
      });
      update();
    });
  }
  if (form) {
    var q = form.querySelector('[name="quantity"]');
    if (q) q.addEventListener('change', update);
  }
  update();

  /* Build the payload the cart API expects. Exposed for testing without a
     purchasable product. */
  function buildItems() {
    var mainId = form && form.querySelector('[name="id"]:not([disabled])');
    var items = [];
    if (mainId) items.push({ id: parseInt(mainId.value, 10), quantity: qty() });
    /* one included pack per Grassifier, not one per click */
    lockedRows.forEach(function (el) {
      items.push({ id: parseInt(el.dataset.lockedVariant, 10), quantity: qty() });
    });
    checked().forEach(function (i) {
      items.push({ id: parseInt(i.dataset.variantId, 10), quantity: 1 });
    });
    return items;
  }
  root.rgppBuildItems = buildItems;

  if (!form) return;

  /* The theme drives the buy button through jQuery, which fires `submit` on the
     form twice for a single click - once natively and once through its own
     trigger. Without a lock that puts every line item in the cart twice. */
  var inflight = false;

  form.addEventListener('submit', function (e) {
    /* locked items mean we intercept even when nothing is ticked - otherwise the
       theme's own submit adds the product alone and the liners are lost */
    if (!checked().length && !lockedRows.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (inflight) return;
    inflight = true;

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    function post(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      });
    }

    /* If a locked item is refused - it sold out and the variant denies
       overselling - drop it and add the rest. Losing the liner off one order is
       bad; blocking the sale entirely is worse. */
    post(buildItems())
      .then(function (res) {
        if (res.ok || !lockedRows.length) return res;
        var locked = lockedRows.map(function (el) { return parseInt(el.dataset.lockedVariant, 10); });
        var without = buildItems().filter(function (it) { return locked.indexOf(it.id) === -1; });
        return without.length ? post(without) : res;
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description || 'Could not add to cart');
        /* let the theme refresh its own cart UI if it listens for this */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        window.location.href = '/cart';
      })
      .catch(function (err) {
        var msg = form.querySelector('.product-form__error-message');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        else { window.alert(err.message); }
      })
      .finally(function () {
        /* stays locked on success - the page is navigating to /cart anyway */
        inflight = false;
        if (btn) btn.removeAttribute('aria-busy');
      });
  }, true);
})();
